export type Language = {
    code: string;
    label: string;
};

export type DiversState = {
    enabledLanguages: Record<string, boolean>;
    defaultLanguage: string;
};

export const LANGUAGES: Language[] = [
    { code: "fr", label: "Français" },
    { code: "en", label: "Anglais" },
    { code: "ru", label: "Russe" },
    { code: "it", label: "Italien" },
    { code: "es", label: "Espagnol" },
    { code: "pt", label: "Portugais" },
    { code: "de", label: "Allemand" },
    { code: "ar", label: "Arabic" },
];
